export default __webpack_public_path__ + "static/media/26-1_person.98721b67.svg";